import { eModelAsset, Game } from "../../Game";
import { FSHADER_END_CHUNK } from "../../ShaderChunks";
import { RoundManager } from "../Round/RoundManager";
import { CameraFlashFxManager } from "./CameraFlashFx";
import { GrandstandCrowd } from "./Crowd";
import { FlagManager, FlagSettings } from "./Decorations/Flags";
import { GrandstandZoneMng } from "./GrandstandZone";
import { SmokeBombMng } from "./SmokeBomb";



export class Grandstand {
    /**
     * Posun tribuny v hernim svete
     */
    static readonly SHIFT_OFFSET = new pc.Vec3(0, -1, 0);

    /**
     * Sklon tribuny v radianech
     */
    static readonly TILT_ANGLE = 50 * pc.math.DEG_TO_RAD;
    /**
     * Krok po tribune na ose Y
     */
    static readonly TILT_STEP_Y = Math.sin(Grandstand.TILT_ANGLE);
    /**
     * Krok po tribune na ose Z
     */
    static readonly TILT_STEP_Z = -Math.cos(Grandstand.TILT_ANGLE);

    // Shader chunk, ktery ztmavuje tribunu smerem do hloubky
    private static readonly DARKNESS_START_Z = (-60).toFixed(1);
    private static readonly DARKNESS_END_Z = (-77).toFixed(1);

    private static readonly FSHADER_COLOR_FILTER = "";//gl_FragColor.rgb *= vec3(0.7, 0.7, 1.0);";
    private static readonly FSHADER_DARKNESS_FLITER = "gl_FragColor.rgb = mix(gl_FragColor.rgb, vec3(0, 0, 0), clamp((vPositionW.z - " + Grandstand.DARKNESS_START_Z + ") / (" + Grandstand.DARKNESS_END_Z + " - " + Grandstand.DARKNESS_START_Z + "), 0.0, 1.0)); \n";
    /**
     * Fragment shader end chunk pro vykresleni obsahu tribuny
     */
    static readonly FSHADER_END_CHUNK = FSHADER_END_CHUNK + Grandstand.FSHADER_COLOR_FILTER + Grandstand.FSHADER_DARKNESS_FLITER;

    /**
     * Divaci
     */
    private _crowd: GrandstandCrowd;
    /**
     * Zony pro zobrazeni efektu nad divaky
     */
    get zones(): GrandstandZoneMng { return this._zones; }
    private _zones: GrandstandZoneMng;

    private _cameraFlashFxs: CameraFlashFxManager;
    private _flags: FlagManager[];
    private _smokeBombs: SmokeBombMng;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        // Tribuna
        let grandstand = new pc.Entity();

        grandstand.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            asset: Game.app.assets.find(eModelAsset.grandstand, pc.eAssetType.model),
            castShadows: false,
            receiveShadows: false,
            isStatic: true
        });

        let mat = (<pc.StandardMaterial>grandstand.model.meshInstances[0].material).clone();
        mat.chunks.endPS = Grandstand.FSHADER_END_CHUNK;

        grandstand.model.meshInstances[0].material = mat;
        (<pc.StandardMaterial>grandstand.model.meshInstances[1].material).chunks.endPS = Grandstand.FSHADER_END_CHUNK;

        grandstand.setPosition(Grandstand.SHIFT_OFFSET);
        Game.app.root.addChild(grandstand);

        // Zony
        this._zones = new GrandstandZoneMng([
            { pos: new pc.Vec3(-24.5, 9, -71).add(Grandstand.SHIFT_OFFSET), size: new pc.Vec2(22, 15) },
            { pos: new pc.Vec3(0.6, 9, -71).add(Grandstand.SHIFT_OFFSET), size: new pc.Vec2(22, 15) },
            { pos: new pc.Vec3(25.6, 9, -71).add(Grandstand.SHIFT_OFFSET), size: new pc.Vec2(22, 15) },
        ]);

        // Divaci
        this._crowd = new GrandstandCrowd(grandstand);

        // Efekty zablesku kamer
        this._cameraFlashFxs = new CameraFlashFxManager(this);

        // Vlajky
        let atlas = Game.atlas;

        mat = new pc.StandardMaterial();
        mat.diffuseMap = atlas.texture;
        mat.blendType = pc.BLEND_NORMAL;
        mat.opacityMap = Game.atlas.texture;
        mat.opacityMapChannel = "a";
        mat.alphaTest = 0.3;
        mat.chunks.endPS = Grandstand.FSHADER_END_CHUNK;
        mat.update();

        let flagsPerType: number[] = [10, 10];

        this._flags = [];

        for (let zoneId = 0; zoneId < 3; zoneId++) {
            let flagSettings: FlagSettings[] = [];

            for (let typeId = 0; typeId < 2; typeId++)
                for (let i = 0; i < flagsPerType[typeId]; i++)
                    flagSettings.push({ typeId: typeId, pos: new pc.Vec3().copy(this._zones.getZoneRndPos(1, 2, zoneId)) });

            this._flags.push(new FlagManager(zoneId, flagSettings, mat));
        }

        // Dymovnice
        this._smokeBombs = new SmokeBombMng(this._zones);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._cameraFlashFxs.reset();
    }

    //-------------------------------------------------------------------------
    /**
     * Priprava na nove kolo hry
     */
    //-------------------------------------------------------------------------
    prepareNewRound(): void {
        let actZoneMask = RoundManager.instance.roundSetup.actZoneMask;

        // Povolit/zakazat vlajky podle masky aktivnich zon
        for (let zoneId = 0; zoneId < this._flags.length; zoneId++) {
            if ((this._flags[zoneId].isActive = (actZoneMask & (1 << zoneId)) != 0))
                this._flags[zoneId].reset();
        }

        this._smokeBombs.prepareNewRound();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        //Game.app.batcher.markGroupDirty(this._flagsBatchGroupId);
        this._crowd.update();
        this._cameraFlashFxs.update();

        this._flags.forEach((flags: FlagManager): void => {
            flags.update();
        });

        this._smokeBombs.update();
    }
}